$(function () {
	if ($(window).width() <= 1279) {
		$('.js-offer-item').click(function () {
			$(this).toggleClass('offer__item-heading_active').next().slideToggle();
		});
	}
})